import { configureStore } from '@reduxjs/toolkit';
import logger from 'redux-logger';
import rootReducer from '~/App/rootReducer';
import { LOGGER_ENABLED } from '~/constants';

export const setupStore = () =>
  configureStore({
    reducer: rootReducer,
    devTools: LOGGER_ENABLED,
    middleware: (getDefaultMiddleware) =>
      /* istanbul ignore next LOGGER_ENABLEDは環境変数のため */
      LOGGER_ENABLED ? getDefaultMiddleware().concat(logger) : getDefaultMiddleware(),
  });

const store = setupStore();
export type RootState = ReturnType<typeof store.getState>;
export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = AppStore['dispatch'];
